import _TableBody from "@mui/material/TableBody";
import React from 'react';
import { defaultEnvironment } from '../../environment';
import Item from './item';
export const fakeEmployees = [{
  id: -1,
  username: 'Lycaon Doué',
  employee: null,
  profilePicture: null
}, {
  id: -1,
  username: 'Dromadaire Naturel',
  employee: null,
  profilePicture: null
}, {
  id: -1,
  username: 'Salamandre Diligente',
  employee: null,
  profilePicture: null
}, {
  id: -1,
  username: 'Licorne Efficace',
  employee: null,
  profilePicture: null
}];
function FakeItems({
  Card,
  userType,
  challenge,
  isEventWithOffer,
  subgroup,
  isCompany,
  leaderboard,
  displaySubgroups,
  displayType,
  showSiteColumn,
  showTeamColumn,
  teams,
  subsidiaries,
  regions,
  exporting,
  disableContact,
  selectedUsers
}) {
  return /*#__PURE__*/React.createElement(_TableBody, {
    sx: {
      position: 'relative'
    }
  }, fakeEmployees.map((item, index) => /*#__PURE__*/React.createElement(Item, {
    blurred: true,
    challenge: challenge,
    disableContact: disableContact,
    displaySubgroups: displaySubgroups,
    displayType: displayType,
    exporting: exporting,
    index: index,
    isCompany: isCompany,
    item: {
      ...item,
      progressValue: 0,
      rank: index + (displayType === 'individual' ? defaultEnvironment.freeOfferEmployeesLeaderboardsMaxRowsCount : defaultEnvironment.freeOfferSubgroupsLeaderboardsMaxRowsCount) + 1
    },
    key: index,
    leaderboard: leaderboard,
    regions: regions,
    selectedUsers: selectedUsers,
    showSiteColumn: showSiteColumn,
    showTeamColumn: showTeamColumn,
    subgroup: subgroup,
    subsidiaries: subsidiaries,
    teams: teams,
    userType: userType
  })), Card && /*#__PURE__*/React.createElement("tr", {
    style: {
      border: 0
    }
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Card, {
    isEventWithOffer: isEventWithOffer
  }))));
}
export default FakeItems;